<template>
  <div>
    <div class="sebrae">
      <img
        style="width: 70px; margin-left: auto"
        src="https://slide1-images.s3.amazonaws.com/public/sebrae-logo.png"
      />
      <div
        style="
          margin-left: auto;
          display: flex;
          column-gap: 10px;
          align-items: center;
        "
      >
        <div>{{ getFirstName() }}</div>
        <div>|</div>
        <div class="buttonSair" @click="logout">sair</div>
      </div>
    </div>
    <div class="seloHeader degrade-background-sebrae">
      <div class="tituloSelo">
        <v-app-bar-nav-icon
          color="#000"
          @click.stop="$emit('sendDrawer', (showDrawer = !drawer))"
        ></v-app-bar-nav-icon>

        Inscrições - <span>Selo Sebrae de Referência em Atendimento</span>
      </div>
      <div
        class="medalhas"
        style="cursor: pointer"
        @click="$router.push('/listar')"
      >
        <img
          :src="getSeloImageUrl('seloMedalhaBronze')"
          @error="handleImageError($event, 'seloMedalhaBronze')"
        />
        <img
          :src="getSeloImageUrl('seloMedalhaPrata')"
          @error="handleImageError($event, 'seloMedalhaPrata')"
        />
        <img
          :src="getSeloImageUrl('seloMedalhaOuro')"
          @error="handleImageError($event, 'seloMedalhaOuro')"
        />
        <img
          :src="getSeloImageUrl('seloMedalhaDiamante')"
          @error="handleImageError($event, 'seloMedalhaDiamante')"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import seloImageManager from "@/helpers/seloImageUtils";

export default {
  data() {
    return {
      showDrawer: this.drawer,
    };
  },
  props: {
    drawer: { type: Boolean, required: true, default: false },
  },
  computed: {
    ...mapGetters(["isFullAdmin"]),
  },
  mounted() {},
  methods: {
    ...mapActions(["setForcedLogout"]),
    getFirstName() {
      var user = JSON.parse(localStorage.getItem("user"));
      if (user) return user.nome.split(" ")[0];

      return "";
    },
    logout() {
      console.log("ala");
      this.setForcedLogout(true);
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/inscricao/auth/login");
      });
    },
    getSeloImageUrl(imageName) {
      return seloImageManager.getImageUrl(imageName);
    },
    handleImageError(event, imageName) {
      seloImageManager.handleImageError(event, imageName);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/variables.scss";

.buttonSair {
  background-color: #5c8bb9;
  color: white;
  padding: 5px 15px;
  border-radius: 5px;
  cursor: pointer;
  margin-left: auto;
}

.buttonSair:hover {
  background-color: #284395;
}

.sebrae {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px 20px;
}
.seloHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 10px;
  font-size: 1.7rem;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
}
.tituloSelo {
  color: $cor-selo-texto;
  font-weight: bold;
}
.medalhas {
  display: flex;
  align-items: center;
  img {
    width: 90px;
  }
}

@media screen and (max-width: 700px) {
  .seloHeader {
    flex-direction: column;
    row-gap: 20px;
  }
  .tituloSelo {
    display: flex;
    flex-direction: column;
    text-align: center;
  }
}
</style>
